import React from 'react';
import {
  FormContainer,
  NameInput,
  TextIcon,
  DummySpaceComponent,
  InputContainer,
  CloseIcon,
} from './style';
import Form from 'components/form';
import { noop } from 'lodash';

export interface LinkNameInputProps {
  name: string;
  value: string;
  placeholder?: string;
  onBlur?: Function;
  disabled?: boolean;
}

const defaultProps = {};

function LinkNameInput({ value, ...props }: LinkNameInputProps) {
  const [isFocused, setFocused] = React.useState<boolean>(false);

  function toggleFocus() {
    setFocused(true);
  }

  function onBlur(event) {
    setFocused(false);
    props.onBlur && props.onBlur(event);
  }

  function onCloseIconClick() {
    setFocused(false);
  }

  return (
    <Form initialValues={{ linkName: value }} onSubmit={noop}>
      {() => {
        return (
          <FormContainer>
            <DummySpaceComponent />
            <InputContainer>
              <NameInput
                {...props}
                $isFocused={isFocused}
                onFocus={toggleFocus}
                onBlur={onBlur}
                iconLeft={<TextIcon />}
                iconRight={
                  isFocused && <CloseIcon onClick={onCloseIconClick} />
                }
                disabled={props.disabled}
              />
            </InputContainer>
          </FormContainer>
        );
      }}
    </Form>
  );
}

LinkNameInput.defaultProps = defaultProps;

export default LinkNameInput;
